<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
  <g>
    <g>
      <path d="M7.5,0A7.5,7.5,0,1,0,15,7.5,7.5,7.5,0,0,0,7.5,0Zm3.17,8.2H4.33V6.8h6.34Z"/>
    </g>
  </g>
</svg>
